// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"321":"081575b0","887":"a4115cde"}[chunkId] + ".chunk.css";
};